class SiteElementImage
    extends QueryElement<HTMLImageElement> {
    
    constructor(card: ISiteCard, element: HTMLImageElement) {
        super(element, false);

        let path = this.getAttr('data-path');
        let crop = this.getAttr('data-image-crop') == "True";
        let dimensions = this.getAttr('data-image-dimensions');
        let fullPath = (path && SiteModel.split(path)) || [];

        let value = card.ModelData.get(fullPath.concat("info"));

        if (Array.isArray(value) && value.length > 0)
            value = value[0];
        
        if (value != null)
            element.src = (<string>(value.preview || "")).replace("/$$$x$$$/", `/${crop ? "c" : "o"}=${dimensions}/`);

        let parent = this.parent();
        if (parent) {
            parent.on("click", (e) => {
                if (e.target == e.currentTarget || e.target == element) {
                    if (parent)
                        parent.toggleClass('collapsed');
                }
            });
        }
    }
}